import axios from 'axios'
import { useEffect, useState } from 'react'
import './BATIMACCLayout.scss'

import { useContext } from 'react'
import { useTranslation } from 'react-i18next'
import Cookies from "universal-cookie"
import { AppContext } from '../../App'
import ChangeEntreprise from '../../ChangeEntreprise'
import DisconnectButton from '../../DisconnectButton'
import { ROUTE } from '../../Routes'
import { error } from '../../Utils/Error'
import { getReseauFromLangue } from '../../Utils/ReseauFromLangue'
import { ServiceType } from '../../Utils/Types'
import { useDomaine } from '../../Utils/Url'

export default function BATIMACCLayout(props: any) {
  const { t } = useTranslation()
  const [state] = useContext(AppContext)
  const domaine = useDomaine()
  const publicURL = process.env.PUBLIC_URL
  const cookies = new Cookies()
  const querySite = cookies.get('QUERY') || ''

  const [logoMacc, setLogoMACC] = useState('bandeau-entete-macc-fr_FR')
  const [coordonneeMACC, setCoordonneeMACC] = useState<undefined | ServiceType>(undefined)
  const langue = localStorage.getItem("i18nextLng") ? localStorage.getItem("i18nextLng") : 'fr-FR'
  const drapeau = langue?.split('-').length === 2 ? langue?.split('-')[1].toLowerCase() : langue?.toLowerCase()
  const autoriserFacture = ['FRA', 'AGR', 'FIL', 'EXP'].includes(state.auth.user.codeReseau)
  const autoriserCompte = process.env.REACT_APP_ENABLE_FEATURE_MES_COORDONNEE_BANCAIRE === "true" && state.auth.entreprise?.hasAccessCompteEtMandat

  const changeFavicon = () => {
    // @ts-expect-error
    document.getElementById("favicon1").href = "/img/cropped-favicon-plat-150x150.png"
    // @ts-expect-error 
    document.getElementById("favicon2").href = "/img/cropped-favicon-plat-200x200.png"
    // @ts-expect-error 
    document.getElementById("favicon3").href = "/img/cropped-favicon-plat-200x200.png"
    // @ts-expect-error 
    document.getElementById("favicon4").content = "/img/cropped-favicon-plat-200x200.png"
    document.getElementById('cssagrimacc')?.remove()
  }

  useEffect(() => {
    changeFavicon()
  }, [])

  useEffect(() => {
    switch (langue) {
      case 'it-IT':
        setLogoMACC('bandeau-entete-macc-it_IT')
        break
      case 'en-GB':
        setLogoMACC('bandeau-entete-macc-en_GB')
        break
      case 'de-BE':
      case 'de-DE':
      case 'de-LU':
        setLogoMACC('bandeau-entete-macc-de_DE')
        break
      case 'es-ES':
        setLogoMACC('bandeau-entete-macc-es_ES')
        break
      case 'nl-BE':
      case 'nl-NL':
        setLogoMACC('bandeau-entete-macc-nl_NL')
        break
      default:
        setLogoMACC('bandeau-entete-macc-fr_FR')
        break;
    }
  }, [langue])

  useEffect(() => {
    let codeReseau: string = state.auth.logged ? state.auth.user.codeReseau ? state.auth.user.codeReseau : getReseauFromLangue(langue) : getReseauFromLangue(langue)
    if (localStorage.getItem('gen_' + codeReseau) != null) {
      setCoordonneeMACC(JSON.parse(localStorage.getItem('gen_' + codeReseau) || ''))
    } else {
      const URL_API: string = `/servicesMACC/reseau/${codeReseau}/type/gen?langue=${langue}`
      axios.get(URL_API)
        .then(
          response => {
            setCoordonneeMACC(response.data)
            localStorage.setItem('gen_' + codeReseau, JSON.stringify(response.data))
          })
        .catch(e => error(e))
    }
  }, [state, langue])

  const handleActiveMenuItem = (urlMenuItem: string) => {
    if (window.location.href.indexOf(urlMenuItem) > -1) {
      return "current-menu-item"
    } else {
      return ""
    }
  }

  return (
    <div className='macc'>
      <div className="direct-menu">
        <a href="#nav">{t('LAYOUT.SCREEN_READER.aller-au-menu')}</a>
        <a href="#main">{t('LAYOUT.SCREEN_READER.aller-au-contenu')}</a>
        <a href="#search">{t('LAYOUT.SCREEN_READER.aller-a-la-recherche')}</a>
      </div>
      <header id="header" role="banner">
        <div className="global-header header-first">
          <div className="header-logo">
            <a href={domaine + querySite} className="custom-logo-link" rel="home">
              <picture className="custom-logo">
                <img width="1140" height="157" src={`${publicURL}/img/${logoMacc}.jpg`} alt="MACC" />
              </picture>
            </a>
          </div>
        </div>
        <div className="menu-mobile">
          <button className="menu-mobile-burger"><span className="screen-reader-text">{t("LAYOUT.SCREEN_READER.ouvrir-menu")}</span></button>
        </div>
        <nav id="nav" role="navigation" aria-label="Menu principal">
          <div className="global-header">
            <div className="menu-header-main">
              <ul id="menu-header-main" className="menu-entete" role="menubar">
                <li id="menu-item-73" className="menu-item menu-item-type-post_type_archive menu-item-object-products menu-item-73" role="none"><a href={domaine + t('HEADER.LINK.produits') + querySite} aria-current="page" aria-haspopup="true" aria-expanded="false" role="menuitem" tabIndex={0}>{t("HEADER.produits")}</a></li>
                <li id="menu-item-34" className="menu-item menu-item-type-post_type menu-item-object-page menu-item-has-children menu-item-34" role="none"><a href={domaine + t('HEADER.LINK.qui-sommes-nous') + querySite} aria-haspopup="true" aria-expanded="false" role="menuitem" tabIndex={-1}>{t('HEADER.qui-sommes-nous')}</a>
                  <ul className="sub-menu" role="menu">
                    <li id="menu-item-1037" className="menu-item menu-item-type-post_type menu-item-object-page menu-item-1037" role="none"><a href={domaine + t('HEADER.LINK.qui-sommes-nous') + querySite} aria-haspopup="true" aria-expanded="false" role="menuitem" tabIndex={-1}>{t('HEADER.groupe-MACC')}</a></li>
                    <li id="menu-item-444" className="menu-item menu-item-type-post_type menu-item-object-page menu-item-444" role="none"><a href={domaine + t('HEADER.LINK.nos-valeurs') + querySite} aria-haspopup="true" aria-expanded="false" role="menuitem" tabIndex={-1}>{t('HEADER.nos-valeurs')}</a></li>
                  </ul>
                </li>
                <li id="menu-item-33" className="menu-item menu-item-type-post_type menu-item-object-page menu-item-has-children menu-item-33" role="none"><a href={domaine + t('HEADER.LINK.innover-ensemble') + querySite} aria-haspopup="true" aria-expanded="false" role="menuitem" tabIndex={-1}>{t('HEADER.innover-ensemble')}</a>
                  <ul className="sub-menu" role="menu">
                    <li id="menu-item-1056" className="menu-item menu-item-type-post_type menu-item-object-page menu-item-1056" role="none"><a href={domaine + t('HEADER.LINK.innover-ensemble') + querySite} aria-haspopup="true" aria-expanded="false" role="menuitem" tabIndex={-1}>{t('HEADER.innover-et-collaborer-avec-la-MACC')}</a></li>
                    <li id="menu-item-1055" className="menu-item menu-item-type-post_type menu-item-object-page menu-item-1055" role="none"><a href={domaine + t('HEADER.LINK.deposer-une-idee') + querySite} aria-haspopup="true" aria-expanded="false" role="menuitem" tabIndex={-1}>{t('HEADER.deposer-une-idee')}</a></li>
                  </ul>
                </li>
                <li id="menu-item-32" className="menu-item menu-item-type-post_type menu-item-object-page menu-item-has-children menu-item-32" role="none"><a href={domaine + t('HEADER.LINK.nous-rejoindre') + querySite} aria-haspopup="true" aria-expanded="false" role="menuitem" tabIndex={-1}>{t('HEADER.nous-rejoindre')}</a>
                  <ul className="sub-menu" role="menu">
                    {drapeau !== 'gb' && <li id="menu-item-1072" className="menu-item menu-item-type-post_type menu-item-object-page menu-item-1072" role="none"><a href={domaine + t('HEADER.LINK.nous-rejoindre') + querySite} aria-haspopup="true" aria-expanded="false" role="menuitem" tabIndex={-1}>{t('HEADER.pourquoi-nous-rejoindre')}</a></li>}
                    {drapeau !== 'gb' && <li id="menu-item-82" className="menu-item menu-item-type-post_type menu-item-object-page menu-item-82" role="none"><a href={domaine + t('HEADER.LINK.le-metier-de-responsable-de-secteur') + querySite} aria-haspopup="true" aria-expanded="false" role="menuitem" tabIndex={-1}>{t('HEADER.le-metier-de-responsable-de-secteur')}</a></li>}
                    {drapeau !== 'gb' && <li id="menu-item-85" className="line menu-item menu-item-type-custom menu-item-object-custom menu-item-85" role="none"><a href={drapeau !== 'fr' ? (domaine + t('HEADER.LINK.postes-a-pourvoir') + querySite) : t('HEADER.LINK.postes-a-pourvoir')} aria-haspopup="true" aria-expanded="false" role="menuitem" tabIndex={-1}>{t('HEADER.postes-a-pourvoir')}</a></li>}
                    <li id="menu-item-86" className="menu-item menu-item-type-custom menu-item-object-custom menu-item-86" role="none"><a href={drapeau !== 'fr' ? domaine + t('HEADER.LINK.candidature-spontanee') + querySite : t('HEADER.LINK.candidature-spontanee')} aria-haspopup="true" aria-expanded="false" role="menuitem" tabIndex={-1}>{t('HEADER.candidature-spontanee')}</a></li>
                  </ul>
                </li>
                <li id="menu-item-35" className={"menu-item menu-item-type-post_type menu-item-object-page menu-item-has-children menu-item-35 " + handleActiveMenuItem(ROUTE.DASHBOARD)} role="none"><a href={process.env.PUBLIC_URL + ROUTE.DASHBOARD} aria-haspopup="true" aria-expanded="false" role="menuitem" tabIndex={-1}>{t('HEADER.mon-compte')}</a>
                  {state.auth.logged &&
                    <ul className="sub-menu" role="menu">
                      <li id="menu-item-87" className="menu-item menu-item-type-post_type menu-item-object-page menu-item-87" role="none"><a href={process.env.PUBLIC_URL + ROUTE.PARC_PRODUITS} aria-haspopup="true" aria-expanded="false" role="menuitem" tabIndex={-1}>{t('HEADER.mon-parc-produits')}</a></li>
                      <li id="menu-item-88" className="menu-item menu-item-type-post_type menu-item-object-page menu-item-88" role="none"><a href={process.env.PUBLIC_URL + ROUTE.INFOS_PERSONNEL} aria-haspopup="true" aria-expanded="false" role="menuitem" tabIndex={-1}>{t('HEADER.mes-informations')}</a></li>
                      {autoriserFacture && <li id="menu-item-89" className="menu-item menu-item-type-post_type menu-item-object-page menu-item-89" role="none"><a href={process.env.PUBLIC_URL + ROUTE.FACTURES} aria-haspopup="true" aria-expanded="false" role="menuitem" tabIndex={-1}>{t('HEADER.mes-factures')}</a></li>}
                      {autoriserCompte && <li id="menu-item-90" className="menu-item menu-item-type-post_type menu-item-object-page menu-item-90" role="none"><a href={process.env.PUBLIC_URL + ROUTE.COORDONNEE_BANCAIRE} aria-haspopup="true" aria-expanded="false" role="menuitem" tabIndex={-1}>{t('HEADER.mes-coordonnees-bancaires')}</a></li>}
                    </ul>
                  }
                </li>
                <li id="menu-item-1026" className={"menu-item menu-item-type-custom menu-item-object-custom menu-item-1026 " + handleActiveMenuItem(ROUTE.INTERLOCUTEURS)} role="none"><a href={process.env.PUBLIC_URL + ROUTE.INTERLOCUTEURS} aria-haspopup="true" aria-expanded="false" role="menuitem" tabIndex={-1}>{t('HEADER.contact')}</a></li>
                <li id="menu-item-74" className="menu-item menu-item-type-post_type menu-item-object-page current_page_parent menu-item-74" role="none"><a href={domaine + t('HEADER.LINK.actualites') + querySite} aria-haspopup="true" aria-expanded="false" role="menuitem" tabIndex={-1}>{t('HEADER.actualites')}</a></li>
                <li id="menu-item-169" className="menu-item menu-item-type-post_type menu-item-object-page menu-item-169" role="none"><a href={domaine + t('HEADER.LINK.faq') + querySite} aria-haspopup="true" aria-expanded="false" role="menuitem" tabIndex={-1}>{t('HEADER.faq')}</a></li>
              </ul>
            </div>
            <a href="/" className="logo-mobile"><img src={`${publicURL}/img/logo-macc.png`} height="51" width="95" alt="MACC" /></a>
            <div className="header-tools">
              <div className="header-langs">
                <div className="current-lang"><img src={`${publicURL}/img/flag-${drapeau}.png`} width="25" height="17" alt='' /></div>
                <ul className="select-lang">
                  <li><img src={`${publicURL}/img/flag-fr.png`} width="25" height="17" alt={t('LAYOUT.FLAG_ALT.france')} /> <a href="https://www.macc.fr/">{t('LAYOUT.LANGUE.france')}</a></li>
                  <li><img src={`${publicURL}/img/flag-es.png`} width="25" height="17" alt={t('LAYOUT.FLAG_ALT.espana')} /> <a href="https://www.macc.es/">{t('LAYOUT.LANGUE.espana')}</a></li>
                  <li><img src={`${publicURL}/img/flag-it.png`} width="25" height="17" alt={t('LAYOUT.FLAG_ALT.italia')} /> <a href="https://www.maccitalia.it/">{t('LAYOUT.LANGUE.italia')}</a></li>
                  <li>
                    <img src={`${publicURL}/img/flag-be.png`} width="25" height="17" alt={t('LAYOUT.FLAG_ALT.belgique')} />
                    <ul>
                      <li><a href="https://www.maccbenelux.be/fr/">{t('LAYOUT.LANGUE.belgique-francais')}</a></li>
                      <li><a href="https://www.maccbenelux.be/de/">{t('LAYOUT.LANGUE.belgien-deutsch')}</a></li>
                      <li><a href="https://www.maccbenelux.be/nl/">{t('LAYOUT.LANGUE.belgie-nederlands')}</a></li>
                    </ul>
                  </li>
                  <li><img src={`${publicURL}/img/flag-nl.png`} width="25" height="17" alt={t('LAYOUT.FLAG_ALT.nederland')} /> <a href="https://www.maccbenelux.be/nl/">{t('LAYOUT.LANGUE.nederland')}</a></li>
                  <li>
                    <img src={`${publicURL}/img/flag-lu.png`} width="25" height="17" alt={t('LAYOUT.FLAG_ALT.luxembourg')} />
                    <ul>
                      <li><a href="https://www.maccbenelux.be/fr/">{t('LAYOUT.LANGUE.luxembourg-francais')}</a></li>
                      <li><a href="https://www.maccbenelux.be/de/">{t('LAYOUT.LANGUE.luxemburg-deutsch')}</a></li>
                    </ul>
                  </li>
                  <li><img src={`${publicURL}/img/flag-uk.png`} width="25" height="17" alt={t('LAYOUT.FLAG_ALT.england')} /> <a href="https://www.macc-uk.com/">{t('LAYOUT.LANGUE.england')}</a></li>
                  <li><a href="https://www.agrimacc.fr/"><img src={`${publicURL}/img/flag-agrimacc.png`} width="35" height="17" alt="AgriMACC" /> AgriMACC</a></li>
                </ul>
              </div>
              <div className="header-search">
                <button className="js-modal" data-modal-content-id="modal-search" data-modal-title="Recherche" data-modal-close-text="Fermer" data-modal-close-title="Fermer cette fenêtre"><span className="icon-search" aria-hidden="true"></span><span className="screen-reader-text">{t('LAYOUT.SCREEN_READER.recherche')}</span></button>
              </div>
              <div className="header-basket">
                <a href={domaine + t('HEADER.LINK.panier') + querySite}>
                  <span className="screen-reader-text">{t('LAYOUT.SCREEN_READER.aller-au-panier')}</span>
                  <span className="icon-basket" aria-hidden="true"></span>
                  {state.panier && state.panier.length > 0 && <span className="num">{state.panier.length}</span>}
                </a>
              </div>
            </div>
          </div>
        </nav>
      </header>

      <main id="main" role="main">
        <div className="global-page">
          <div className="content-styles-macc">
            <div className='header-logged'>
              {state.auth.logged && state.auth.entreprise && <ChangeEntreprise />}
              {state.auth.logged && state.auth.entreprise && <DisconnectButton icone />}
            </div>
            {props.children}
          </div>
        </div>

        <div id="modal-search" className="content-modal-hidden">
          <form role="search" method="get" className="search-form" action={domaine + querySite}>
            <label>
              <span className="screen-reader-text">{t('LAYOUT.rechercher')}</span>
              <input type="search" className="search-field" name="s" title={t('LAYOUT.rechercher')} />
            </label>
            <input type="submit" className="search-submit" value={t('LAYOUT.rechercher') as string} />
          </form>
        </div>
      </main>

      <footer id="footer" role="contentinfo">
        <div className="global-footer">
          <div className="footer-contacts">
            <div className="man">
              <img src={`${publicURL}/img/macc-man-footer.png`} width="95" height="127" alt="Mascotte MACC" />
            </div>
            <section className="col">
              <div className="col-content">
                {coordonneeMACC &&
                  <>
                    <address>
                      <p><strong>{coordonneeMACC.adresseTitre} &#8211; </strong>{coordonneeMACC.adresseLigne1} &#8211; {coordonneeMACC.adresseLigne2} &#8211; {coordonneeMACC.codePostal} {coordonneeMACC.ville}</p>
                    </address>
                    {coordonneeMACC.listSousServices.map((sousService) =>
                      <div className="phone-email" key={sousService.nomSousService}>
                        <div><span className="icon-phone" aria-hidden="true"></span> <a href="tel:33 (0)5 49 02 55 55">{sousService.telephone1}</a></div>
                        <div><span className="icon-email" aria-hidden="true"></span> <a href={'mailto:' + sousService.mail1 + '@' + sousService.mail2}>{sousService.mail1 + '@' + sousService.mail2}</a></div>
                      </div>
                    )}
                  </>
                }
              </div>
              <nav role="navigation" className="footer-menu-pages">
                <div className="footer-menu">
                  <ul id="menu-pied-de-page" className="menu">
                    <li id="menu-item-69" className="menu-item menu-item-type-post_type menu-item-object-page menu-item-privacy-policy menu-item-69"><a href={domaine + t('LAYOUT.LINK.rgpd') + querySite} role="menuitem" tabIndex={-1}>{t("LAYOUT.rgpd")}</a></li>
                    <li id="menu-item-51" className="menu-item menu-item-type-post_type menu-item-object-page menu-item-51"><a href={domaine + t('LAYOUT.LINK.mentions-legales') + querySite} role="menuitem" tabIndex={-1}>{t("LAYOUT.mentions-legales")}</a></li>
                    <li id="menu-item-52" className="menu-item menu-item-type-post_type menu-item-object-page menu-item-52"><a href={domaine + t('LAYOUT.LINK.plan-site') + querySite} role="menuitem" tabIndex={-1}>{t("LAYOUT.plan-site")}</a></li>
                  </ul>
                </div>
                <span className="socials">
                  {t("LAYOUT.suivez_nous")}
                  <a href="https://www.linkedin.com/company/macc-group/" target="_blank" rel="noreferrer"><span className="screen-reader-text">{t('LAYOUT.SCREEN_READER.linkedin')}</span><span className="icon-linkedin" aria-hidden="true"></span></a>
                </span>
              </nav>
            </section>
          </div>
        </div>
      </footer>
    </div>
  )

} 